import React, { useEffect, useState } from 'react';
import { MapPin, Crown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import '../../../../../assets/css/subscreens/customer/dashboard/apphome/appherosection/AppHeroSection.css';

const PromoHero = ({ onClick }) => {

  const navigate = useNavigate();

  const [location, setLocation] = useState("Your Location");

  useEffect(() => {

    if (!navigator.geolocation) {
      setLocation("Location unavailable");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {

        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        try {

          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
          );

          const data = await response.json();

          const city =
            data.address.city ||
            data.address.town ||
            data.address.village ||
            "";

          const country = data.address.country || "";

          setLocation(`${city}, ${country}`);

        } catch (error) {
          console.log(error);
          setLocation("Location unavailable");
        }

      },
      (error) => {
        console.log(error);
        setLocation("Enable Location");
      }
    );

  }, []);


  return (
    <div className="pph-wrap">

      <div className="ph-banner" onClick={onClick}>

        <button
          className="ph-sub-btn"
          onClick={(e) => { 
            e.stopPropagation(); 
            navigate('/customer-subscription'); 
          }}
        >
          <Crown size={13} />
          <span>Go Pro</span>
          <span>✦</span>
        </button>


        <div className="ph-bg-img">
          <img
            src="https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=600&q=80"
            alt="worker"
          />
        </div>


        <div className="ph-content">

          <span className="ph-eyebrow">
            <MapPin size={13} /> 
            {location} Home Services
          </span>


          <h2 className="ph-headline">
            Trusted Experts<br />At Your Door
          </h2>


          <p className="ph-sub">
            Verified professionals for every home need — booked in minutes, done right.
          </p>


          <button
            className="ph-btn"
            onClick={(e)=> {
              e.stopPropagation();
              navigate('/post-a-job');
            }}
          >
            Post a Job
          </button>


        </div>

      </div>

    </div>
  );
};

export default PromoHero;